import T from "../../i18n/Text";
import ConfigActionButtons from "../config-action-buttons/ConfigActionButtons";
import React, {ReactNode} from "react";

interface Props {
    configTitlePath?:string;
    showActionButtons?: boolean;
    nextActionDisabled?: boolean;
    actionButtonsNote?:string;
    nextToPlay?: () => void;
    backToDetails?: () => void;
    backButtonLabelPath?: string;
    nextButtonLabelPath?: string;
    children: ReactNode;
}

const ConfigScreen = ({
                          configTitlePath,
                          showActionButtons= true,
                          nextActionDisabled= false,
                          actionButtonsNote,
                          nextToPlay = () => {},
                          backToDetails = () => {},
                          backButtonLabelPath,
                          nextButtonLabelPath,
                          children
                      }: Props) => {
    const title = <h3 className="text-[36px] font-bold leading-[44px] text-center mb-[29px] md:mb-[38px]">
        <T path={configTitlePath || ''} />
    </h3>;

    const actionButtons = <ConfigActionButtons
        backToDetails={backToDetails}
        nextToPlay={nextToPlay}
        nextDisabled={nextActionDisabled}
        backButtonLabelPath={backButtonLabelPath}
        nextButtonLabelPath={nextButtonLabelPath}
    />;

    const note = <p className="font-light text-[14px] leading-[17px] mt-[11px]">{actionButtonsNote}</p>;

    return <div className="flex flex-col justify-between items-center w-full">
        {configTitlePath && title}
        {children}
        {showActionButtons && actionButtons}
        {actionButtonsNote && note}
    </div>;
};

export default ConfigScreen;
